var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { title: "Procesamiento de documentos" } },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center pt-5"
            },
            [
              _c("b-spinner", {
                staticClass: "mt-5",
                attrs: { variant: "primary" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.fromEditAction
        ? _c("h4", { staticClass: "text-primary" }, [
            _vm._v(
              " Si quieres editar la metadata, realiza las modificaciones antes en el modal a continuación y luego edita el expediente de forma habitual. "
            )
          ])
        : _vm._e(),
      _vm.fromEditAction
        ? _c(
            "b-modal",
            {
              ref: "modalMetadata",
              attrs: {
                size: "xl",
                "hide-footer": "",
                "no-close-on-backdrop": "",
                title: "Metadata del expediente"
              }
            },
            [
              _c("Metadata", {
                attrs: {
                  notify: _vm.notify,
                  fromEdit: _vm.fromEditAction,
                  justificationCompleted: _vm.justificationCompleted
                },
                on: {
                  "is-justified": _vm.setJustification,
                  "close-modal": _vm.closeModalMetadata
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.fromEditAction
        ? _c("div", { staticClass: "row my-5" }, [
            _c(
              "div",
              { staticClass: "col-12 text-left" },
              [
                _vm.fromEditAction
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "mr-2 btn btn-warning",
                        attrs: { disabled: _vm.loading },
                        on: {
                          click: function($event) {
                            return _vm.verMetadata()
                          }
                        }
                      },
                      [_vm._v(" Ver metadata ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.fromEditAction ? _c("hr") : _vm._e(),
      !_vm.loading
        ? _c(
            "form",
            {
              attrs: { autocomplete: "off", "data-vv-scope": "inputDoc" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("vs-input", {
                      staticClass: "w-100",
                      attrs: { label: "Código de Documento", readonly: "" },
                      model: {
                        value: _vm.docCode,
                        callback: function($$v) {
                          _vm.docCode = $$v
                        },
                        expression: "docCode"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("vs-input", {
                      staticClass: "w-100",
                      attrs: { label: "Fecha de ingreso", readonly: "" },
                      model: {
                        value: _vm.inputDate,
                        callback: function($$v) {
                          _vm.inputDate = $$v
                        },
                        expression: "inputDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 mt-2" },
                  [
                    _c("ClassificationList", {
                      model: {
                        value: _vm.classification,
                        callback: function($$v) {
                          _vm.classification = $$v
                        },
                        expression: "classification"
                      }
                    }),
                    _vm.error.clasification
                      ? _c("small", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.error.clasification))
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("ListDocumentTypes", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      ref: "documentTypes",
                      staticClass: "w-100",
                      attrs: {
                        autocomplete: "",
                        label: "Tipo de documento *",
                        placeholder: "Seleccione...",
                        name: "documentType",
                        danger: _vm.errors.has("inputDoc.documentType"),
                        "danger-text": _vm.errors.first("inputDoc.documentType")
                      },
                      model: {
                        value: _vm.documentType,
                        callback: function($$v) {
                          _vm.documentType = $$v
                        },
                        expression: "documentType"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "max:50",
                          expression: "'max:50'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        autocomplete: "off",
                        label: "Número",
                        "data-vv-as": "número de documento",
                        name: "numDoc",
                        danger: _vm.errors.has("inputDoc.numDoc"),
                        "danger-text": _vm.errors.first("inputDoc.numDoc"),
                        success:
                          !_vm.errors.has("inputDoc.numDoc") && !!_vm.numDoc
                      },
                      model: {
                        value: _vm.numDoc,
                        callback: function($$v) {
                          _vm.numDoc = $$v
                        },
                        expression: "numDoc"
                      }
                    })
                  ],
                  1
                ),
                _vm.documentType === "IPCAFTO"
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("label", [_vm._v("Comisiones")]),
                        _c("treeselect", {
                          attrs: {
                            placeholder: "Seleccione...",
                            options: _vm.interestAreas
                          },
                          model: {
                            value: _vm.commissions,
                            callback: function($$v) {
                              _vm.commissions = $$v
                            },
                            expression: "commissions"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.documentType === "IPCAFTO"
                  ? _c(
                      "div",
                      { staticClass: "col-6 mt-1" },
                      [
                        _c("vs-input", {
                          staticClass: "w-100",
                          attrs: { label: "Cantidad de Adhesiones" },
                          model: {
                            value: _vm.adhesion,
                            callback: function($$v) {
                              _vm.adhesion = $$v
                            },
                            expression: "adhesion"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "row mt-1" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", [_vm._v("Es documento madre")]),
                    _c("b-form-select", {
                      staticClass: "w-100",
                      attrs: {
                        "data-cy": "mother-document",
                        options: _vm.isMotherOptions
                      },
                      on: {
                        change: function($event) {
                          _vm.motherDocNumber = undefined
                        }
                      },
                      model: {
                        value: _vm.isMotherDocument,
                        callback: function($$v) {
                          _vm.isMotherDocument = $$v
                        },
                        expression: "isMotherDocument"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isMotherDocument,
                        expression: "!isMotherDocument"
                      }
                    ],
                    staticClass: "col-6"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: !_vm.isMotherDocument },
                              expression: "{ required: !isMotherDocument }"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "off",
                            label: "N° Documento Madre *",
                            "data-vv-as": "n° documento madre",
                            name: "numDocMother",
                            danger: _vm.errors.has("inputDoc.numDocMother"),
                            "danger-text": _vm.errors.first(
                              "inputDoc.numDocMother"
                            ),
                            success:
                              !_vm.errors.has("inputDoc.numDocMother") &&
                              !!_vm.motherDocNumber
                          },
                          on: {
                            keyup: function($event) {
                              return _vm.searchForMother()
                            },
                            change: _vm.deleteMotherReference
                          },
                          model: {
                            value: _vm.motherDocNumber,
                            callback: function($$v) {
                              _vm.motherDocNumber =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "motherDocNumber"
                          }
                        }),
                        (_vm.motherDocumentsList.length > 0 ||
                          _vm.loadingMotherDocuments) &&
                        _vm.showListSelect
                          ? _c(
                              "ul",
                              { attrs: { id: "list" } },
                              [
                                _vm.loadingMotherDocuments
                                  ? _c("li", [
                                      _c(
                                        "span",
                                        { staticClass: "muted-light" },
                                        [_vm._v("Buscando...")]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._l(_vm.motherDocumentsList, function(item) {
                                  return _c(
                                    "li",
                                    {
                                      key: item.numero,
                                      on: {
                                        click: function($event) {
                                          return _vm.updateMotherDoc(item)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v(_vm._s(item.numero))]),
                                      _c(
                                        "span",
                                        { staticClass: "muted-light" },
                                        [
                                          _vm._v(
                                            " creado el " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  item.fechaCreacion
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c("p", [
                                        _vm._v("Creado por "),
                                        _c("b", [
                                          _vm._v(_vm._s(item.solicitanteNombre))
                                        ]),
                                        _vm._v(
                                          " (" +
                                            _vm._s(item.solicitanteEmail) +
                                            ")"
                                        )
                                      ])
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.error.motherDoc
                      ? _c("small", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.error.motherDoc))
                        ])
                      : _vm._e()
                  ]
                ),
                _vm.showStateSelect
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "vs-select",
                          {
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "Estado de la propuesta",
                              placeholder: "Seleccione..."
                            },
                            model: {
                              value: _vm.proposalStatus,
                              callback: function($$v) {
                                _vm.proposalStatus = $$v
                              },
                              expression: "proposalStatus"
                            }
                          },
                          [
                            _c("vs-select-item", {
                              attrs: { value: "approved", text: "Aprobada" }
                            }),
                            _c("vs-select-item", {
                              attrs: {
                                value: "partial-approved",
                                text: "Aprobada parcial"
                              }
                            }),
                            _c("vs-select-item", {
                              attrs: { value: "rejected", text: "Rechazada" }
                            }),
                            _c("vs-select-item", {
                              attrs: { value: "retired", text: "Retirada" }
                            }),
                            _c("vs-select-item", {
                              attrs: {
                                value: "not-processed",
                                text: "No tramitada"
                              }
                            }),
                            _c("vs-select-item", {
                              attrs: {
                                value: "inadmissible",
                                text: "Inadmisible"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-12 mt-3" },
                  [
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "max:1000",
                          expression: "'max:1000'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        autocomplete: "off",
                        label: "Nombre del expediente",
                        name: "nameExp"
                      },
                      model: {
                        value: _vm.titleExp,
                        callback: function($$v) {
                          _vm.titleExp = $$v
                        },
                        expression: "titleExp"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row mt-1 d-flex align-items-end" }, [
                _c("div", { staticClass: "col-12 mt-5" }, [
                  _c("h6", [_vm._v("Remitente:")])
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 d-flex align-items-center" },
                  [
                    _c(
                      "b-form-radio",
                      {
                        staticClass: "ml-3 mr-5",
                        attrs: {
                          disabled:
                            _vm.fromDocDigital ||
                            (_vm.fromEditAction && _vm.categoryNumber !== 1),
                          name: "search",
                          value: "naturalPerson",
                          "data-cy": "natural-person-button"
                        },
                        on: { change: _vm.clearSender },
                        model: {
                          value: _vm.sender,
                          callback: function($$v) {
                            _vm.sender = $$v
                          },
                          expression: "sender"
                        }
                      },
                      [_vm._v(" Ciudadano/a ")]
                    ),
                    _c(
                      "b-form-radio",
                      {
                        staticClass: "mr-5",
                        attrs: {
                          disabled:
                            _vm.fromDocDigital ||
                            (_vm.fromEditAction && _vm.categoryNumber !== 1),
                          name: "search",
                          value: "legalPerson",
                          "data-cy": "legal-person-button"
                        },
                        on: { change: _vm.clearSender },
                        model: {
                          value: _vm.sender,
                          callback: function($$v) {
                            _vm.sender = $$v
                          },
                          expression: "sender"
                        }
                      },
                      [_vm._v(" Persona Jurídica ")]
                    ),
                    _c(
                      "b-form-radio",
                      {
                        staticClass: "mr-5",
                        attrs: {
                          disabled:
                            _vm.fromEditAction && _vm.categoryNumber !== 1,
                          name: "search",
                          value: "stateAgency",
                          "data-cy": "state-agency-button"
                        },
                        on: { change: _vm.clearSender },
                        model: {
                          value: _vm.sender,
                          callback: function($$v) {
                            _vm.sender = $$v
                          },
                          expression: "sender"
                        }
                      },
                      [_vm._v(" Organismo del estado ")]
                    ),
                    _c(
                      "b-form-radio",
                      {
                        staticClass: "mr-5",
                        attrs: {
                          disabled:
                            _vm.fromDocDigital ||
                            (_vm.fromEditAction && _vm.categoryNumber !== 2),
                          name: "search",
                          value: "conventional",
                          "data-cy": "conventional-button"
                        },
                        on: { change: _vm.clearSender },
                        model: {
                          value: _vm.sender,
                          callback: function($$v) {
                            _vm.sender = $$v
                          },
                          expression: "sender"
                        }
                      },
                      [_vm._v(" Convencional ")]
                    ),
                    _c(
                      "b-form-radio",
                      {
                        staticClass: "mr-5",
                        attrs: {
                          disabled:
                            _vm.fromDocDigital ||
                            (_vm.fromEditAction && _vm.categoryNumber !== 2),
                          name: "search",
                          value: "commission",
                          "data-cy": "commission-button"
                        },
                        on: { change: _vm.clearSender },
                        model: {
                          value: _vm.sender,
                          callback: function($$v) {
                            _vm.sender = $$v
                          },
                          expression: "sender"
                        }
                      },
                      [_vm._v(" Comisión ")]
                    ),
                    _c(
                      "b-form-radio",
                      {
                        staticClass: "mr-5",
                        attrs: {
                          disabled:
                            _vm.fromDocDigital ||
                            (_vm.fromEditAction && _vm.categoryNumber !== 2),
                          name: "sender",
                          value: "user",
                          "data-cy": "user-button"
                        },
                        on: { change: _vm.clearSender },
                        model: {
                          value: _vm.sender,
                          callback: function($$v) {
                            _vm.sender = $$v
                          },
                          expression: "sender"
                        }
                      },
                      [_vm._v(" Usuario ")]
                    )
                  ],
                  1
                ),
                _vm.sender === "stateAgency"
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [_vm._v("Organismos del estado")]),
                        _c("b-form-select", {
                          staticClass: "w-100",
                          attrs: {
                            disabled: _vm.fromDocDigital,
                            options: _vm.agencyOptions
                          },
                          model: {
                            value: _vm.agency,
                            callback: function($$v) {
                              _vm.agency = $$v
                            },
                            expression: "agency"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm.sender === "commission"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("list-groups", {
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            name: "group",
                            block: false,
                            typeList: 1,
                            showOnlyCommissions: "",
                            label: "Comisión"
                          },
                          on: { "full-group": _vm.selectCommission },
                          model: {
                            value: _vm.sendToPartsOffice,
                            callback: function($$v) {
                              _vm.sendToPartsOffice = $$v
                            },
                            expression: "sendToPartsOffice"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.sender === "conventional"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("ListUser", {
                          ref: "conventional",
                          staticClass: "w-100 mb-0",
                          attrs: {
                            autocomplete: "",
                            label: "Entrega a oficina de partes",
                            name: "user",
                            "data-cy": "select-parts-office",
                            "data-vv-as": "usuario",
                            onlyConventional: ""
                          },
                          on: { "full-user": _vm.addUserData },
                          model: {
                            value: _vm.sendToPartsOffice,
                            callback: function($$v) {
                              _vm.sendToPartsOffice = $$v
                            },
                            expression: "sendToPartsOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("ListUser", {
                          staticClass: "w-100 mb-0",
                          attrs: {
                            autocomplete: "",
                            label: "Autores",
                            name: "user",
                            "data-vv-as": "usuario",
                            onlyConventional: ""
                          },
                          on: { "full-user": _vm.addAuthor }
                        }),
                        _c("div", [
                          _c(
                            "ul",
                            { staticClass: "d-flex mt-1" },
                            _vm._l(_vm.authors, function(author) {
                              return _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Click para borrar",
                                      expression: "'Click para borrar'"
                                    }
                                  ],
                                  key: author.usuarioAutorId,
                                  staticClass:
                                    "text-primary cursor-pointer mr-2 font-weight-bolder",
                                  on: {
                                    click: function($event) {
                                      return _vm.removeAuthor(
                                        author.usuarioAutorId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(author.usuarioAutorNombre + ",") +
                                      " "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.sender === "user"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("ListUser", {
                          ref: "conventional",
                          staticClass: "w-100 mb-0",
                          attrs: {
                            autocomplete: "",
                            label: "Seleccione el usuario",
                            name: "user",
                            "data-cy": "select-user",
                            "data-vv-as": "usuario"
                          },
                          on: { "full-user": _vm.addUserData },
                          model: {
                            value: _vm.sendToPartsOffice,
                            callback: function($$v) {
                              _vm.sendToPartsOffice = $$v
                            },
                            expression: "sendToPartsOffice"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.sender === "stateAgency" && _vm.agency !== "docDigital"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("vs-input", {
                          staticClass: "w-100",
                          attrs: { autocomplete: "off", label: "Repartición" },
                          model: {
                            value: _vm.distribution,
                            callback: function($$v) {
                              _vm.distribution = $$v
                            },
                            expression: "distribution"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("vs-input", {
                          staticClass: "w-100",
                          attrs: { autocomplete: "off", label: "Firmante" },
                          model: {
                            value: _vm.signer,
                            callback: function($$v) {
                              _vm.signer = $$v
                            },
                            expression: "signer"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.agency === "docDigital"
                ? _c("DocDigitalInputs", {
                    attrs: {
                      entity: _vm.entity,
                      theme: _vm.theme,
                      description: _vm.description,
                      signers: _vm.signers,
                      certifiers: _vm.certifiers
                    }
                  })
                : _vm._e(),
              _vm.sender === "legalPerson"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "max:200",
                              expression: "'max:200'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "off",
                            label: "Representante legal",
                            "data-vv-as": "representante legal",
                            name: "legalRep",
                            danger: _vm.errors.has("inputDoc.legalRep"),
                            "danger-text": _vm.errors.first(
                              "inputDoc.legalRep"
                            ),
                            success:
                              !_vm.errors.has("inputDoc.legalRep") &&
                              _vm.legalRepresentative &&
                              _vm.legalRepresentative.length > 0
                          },
                          model: {
                            value: _vm.legalRepresentative,
                            callback: function($$v) {
                              _vm.legalRepresentative = $$v
                            },
                            expression: "legalRepresentative"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.sender === "naturalPerson" || _vm.sender === "legalPerson"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "validateRut",
                              expression: "'validateRut'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "off",
                            label: "Rut",
                            "data-vv-as": "rut",
                            name: "iut",
                            danger: _vm.errors.has("inputDoc.iut"),
                            "danger-text": _vm.errors.first("inputDoc.iut"),
                            success:
                              !_vm.errors.has("inputDoc.iut") &&
                              _vm.iut.length > 0
                          },
                          model: {
                            value: _vm.iut,
                            callback: function($$v) {
                              _vm.iut = $$v
                            },
                            expression: "iut"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "max:200",
                              expression: "'max:200'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "off",
                            label:
                              _vm.sender === "naturalPerson"
                                ? "Nombre"
                                : "Persona jurídica (Empresa u ONG) *",
                            "data-vv-as":
                              _vm.sender === "naturalPerson"
                                ? "nombre"
                                : "persona jurídica (Empresa u ONG)",
                            name: "name",
                            danger: _vm.errors.has("inputDoc.name"),
                            "danger-text": _vm.errors.first("inputDoc.name"),
                            success:
                              !_vm.errors.has("inputDoc.name") &&
                              _vm.name.length > 0
                          },
                          model: {
                            value: _vm.name,
                            callback: function($$v) {
                              _vm.name = $$v
                            },
                            expression: "name"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.showContactData
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-6 d-flex align-items-end" }, [
                      _c(
                        "div",
                        { staticClass: "w-100" },
                        [
                          _c("ListCommunes", {
                            attrs: {
                              autocomplete: "off",
                              "data-vv-as": "comuna",
                              name: "commune",
                              isClearable: false,
                              danger: _vm.errors.has("inputDoc.commune"),
                              "danger-text": _vm.errors.first(
                                "inputDoc.commune"
                              ),
                              clearCommune: _vm.clearCommune
                            },
                            model: {
                              value: _vm.selectedCommune,
                              callback: function($$v) {
                                _vm.selectedCommune = $$v
                              },
                              expression: "selectedCommune"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("vs-input", {
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "off",
                            label: "Dirección",
                            "data-vv-as": "dirección",
                            name: "address",
                            danger: _vm.errors.has("inputDoc.address"),
                            "danger-text": _vm.errors.first("inputDoc.address"),
                            success:
                              !_vm.errors.has("inputDoc.address") &&
                              _vm.address.length > 0
                          },
                          model: {
                            value: _vm.address,
                            callback: function($$v) {
                              _vm.address = $$v
                            },
                            expression: "address"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.showContactData
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "email|max:100",
                              expression: "'email|max:100'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "off",
                            label: "Correo",
                            "data-vv-as": "correo",
                            name: "email",
                            danger: _vm.errors.has("inputDoc.email"),
                            "danger-text": _vm.errors.first("inputDoc.email"),
                            success:
                              !_vm.errors.has("inputDoc.email") &&
                              _vm.email.length > 0
                          },
                          model: {
                            value: _vm.email,
                            callback: function($$v) {
                              _vm.email = $$v
                            },
                            expression: "email"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.agency.match(/centralAdministration|docDigital/)
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("vs-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { regex: _vm.phoneRegex },
                                  expression: "{ regex: phoneRegex }"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                autocomplete: "off",
                                label: "Teléfono",
                                placeholder: "Escriba en formato +56912345678",
                                "data-vv-as": "teléfono",
                                name: "phone",
                                danger: _vm.errors.has("inputDoc.phone"),
                                "danger-text": _vm.errors.first(
                                  "inputDoc.phone"
                                ),
                                success:
                                  !_vm.errors.has("inputDoc.phone") &&
                                  _vm.phone.length > 0
                              },
                              model: {
                                value: _vm.phone,
                                callback: function($$v) {
                                  _vm.phone = $$v
                                },
                                expression: "phone"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("vs-input", {
                      staticClass: "w-100",
                      attrs: {
                        label: "Descripción",
                        "data-vv-as": "descripción",
                        name: "alternativeTitle"
                      },
                      model: {
                        value: _vm.metadata.description,
                        callback: function($$v) {
                          _vm.$set(_vm.metadata, "description", $$v)
                        },
                        expression: "metadata.description"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("vs-input", {
                      staticClass: "w-100",
                      attrs: {
                        label: "Título alternativo",
                        "data-vv-as": "titulo alternativo",
                        name: "alternativeTitle"
                      },
                      model: {
                        value: _vm.metadata.alternativeTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.metadata, "alternativeTitle", $$v)
                        },
                        expression: "metadata.alternativeTitle"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 mt-3" },
                  [
                    _c("vs-input", {
                      staticClass: "w-100",
                      attrs: {
                        label: "ID SAIP",
                        "data-vv-as": "id Saip",
                        name: "idSaip"
                      },
                      model: {
                        value: _vm.metadata.idSaip,
                        callback: function($$v) {
                          _vm.$set(_vm.metadata, "idSaip", $$v)
                        },
                        expression: "metadata.idSaip"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 mt-3" },
                  [
                    _c("label", [_vm._v("Fecha del documento")]),
                    _c("b-form-datepicker", {
                      attrs: {
                        locale: "es",
                        placeholder: "Fecha del documento",
                        name: "documentDate",
                        "label-help":
                          "Puede usar las flechas del teclado y espacio"
                      },
                      model: {
                        value: _vm.metadata.documentDate,
                        callback: function($$v) {
                          _vm.$set(_vm.metadata, "documentDate", $$v)
                        },
                        expression: "metadata.documentDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 mt-3" },
                  [
                    _c("label", [_vm._v("Fecha de finalización")]),
                    _c("b-form-datepicker", {
                      attrs: {
                        locale: "es",
                        placeholder: "Fecha de finalización",
                        name: "documentEndDate",
                        "label-help":
                          "Puede usar las flechas del teclado y espacio"
                      },
                      model: {
                        value: _vm.metadata.documentEndDate,
                        callback: function($$v) {
                          _vm.$set(_vm.metadata, "documentEndDate", $$v)
                        },
                        expression: "metadata.documentEndDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 mt-3" },
                  [
                    _c("ListUser", {
                      staticClass: "w-100 mb-0",
                      attrs: {
                        autocomplete: "",
                        label: "Autores internos",
                        name: "authors",
                        "data-vv-as": "autores",
                        onlyRol: ""
                      },
                      on: { "full-user": _vm.addInternAuthor }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-5 mt-3" },
                  [
                    _c("vs-input", {
                      staticClass: "w-100",
                      attrs: {
                        label: "Autores externos",
                        "data-vv-as": "autores",
                        name: "authors"
                      },
                      model: {
                        value: _vm.metadata.externalAuthorName,
                        callback: function($$v) {
                          _vm.$set(_vm.metadata, "externalAuthorName", $$v)
                        },
                        expression: "metadata.externalAuthorName"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-5 mt-3" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Rol Autor externo" } },
                      [
                        _c("v-select", {
                          attrs: {
                            label: "descripcion",
                            options: _vm.externAuthorsRoles,
                            reduce: function(rol) {
                              return rol.valor
                            },
                            name: "rolType"
                          },
                          model: {
                            value: _vm.metadata.externalAuthorRol,
                            callback: function($$v) {
                              _vm.$set(_vm.metadata, "externalAuthorRol", $$v)
                            },
                            expression: "metadata.externalAuthorRol"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.metadata.externalAuthorRol === "Otro"
                      ? _c("vs-input", {
                          staticClass: "w-100",
                          attrs: {
                            label: "Rol Autor externo",
                            "data-vv-as": "autores",
                            name: "authors"
                          },
                          model: {
                            value: _vm.metadata.externalAuthorRolFree,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.metadata,
                                "externalAuthorRolFree",
                                $$v
                              )
                            },
                            expression: "metadata.externalAuthorRolFree"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2 mt-5" },
                  [
                    _c(
                      "vs-button",
                      {
                        staticClass: "mr-2 mt-5 btn btn-primary",
                        on: { click: _vm.addExternalAuthor }
                      },
                      [_vm._v(" Agregar ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 mt-3" },
                  [
                    _vm.metadata.internAuthors.length
                      ? _c(
                          "b-table-simple",
                          { attrs: { hover: "", small: "" } },
                          [
                            _c(
                              "b-thead",
                              [
                                _c(
                                  "b-tr",
                                  [
                                    _c("b-th", { attrs: { scope: "col" } }, [
                                      _vm._v("Nombre")
                                    ]),
                                    _c("b-th", { attrs: { scope: "col" } }, [
                                      _vm._v("Rol")
                                    ]),
                                    _c(
                                      "b-th",
                                      {
                                        staticClass: "text-center",
                                        attrs: { scope: "col" }
                                      },
                                      [_vm._v("Acción")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(_vm.metadata.internAuthors, function(
                                internAuthor
                              ) {
                                return _c(
                                  "b-tr",
                                  { key: internAuthor.id },
                                  [
                                    _c("b-td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center"
                                        },
                                        [
                                          _c("vs-icon", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              icon: "description",
                                              size: "medium"
                                            }
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                internAuthor[
                                                  "dc.contributor.name"
                                                ]
                                              ) +
                                              " "
                                          )
                                        ],
                                        1
                                      )
                                    ]),
                                    _c(
                                      "b-td",
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: { readonly: "" },
                                          model: {
                                            value:
                                              internAuthor[
                                                "dc.contributor.type"
                                              ],
                                            callback: function($$v) {
                                              _vm.$set(
                                                internAuthor,
                                                "dc.contributor.type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "internAuthor['dc.contributor.type']"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-td",
                                      { staticClass: "text-center" },
                                      [
                                        _c("vs-icon", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: "Eliminar",
                                              expression: "'Eliminar'"
                                            }
                                          ],
                                          staticClass: "cursor-pointer",
                                          attrs: {
                                            icon: "remove_circle_outline",
                                            size: "small",
                                            color: "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeMetadataAuthor(
                                                "intern",
                                                internAuthor
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 mt-3" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Unidad productora" } },
                      [
                        _c("v-select", {
                          attrs: {
                            label: "label",
                            options: _vm.productionUnitOptions,
                            reduce: function(rol) {
                              return rol.label
                            },
                            name: "productionUnit"
                          },
                          model: {
                            value: _vm.metadata.productionUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.metadata, "productionUnit", $$v)
                            },
                            expression: "metadata.productionUnit"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.metadata.productionUnit === "Otro"
                  ? _c(
                      "div",
                      { staticClass: "col-6 mt-3" },
                      [
                        _c("vs-input", {
                          staticClass: "w-100",
                          attrs: {
                            label: "Unidad productora",
                            "data-vv-as": "unidad productora",
                            name: "productionUnitOther"
                          },
                          model: {
                            value: _vm.metadata.productionUnitOther,
                            callback: function($$v) {
                              _vm.$set(_vm.metadata, "productionUnitOther", $$v)
                            },
                            expression: "metadata.productionUnitOther"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("hr", {}),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("h4", [_vm._v("Destinatario")]),
                    _vm.error.subject
                      ? _c("small", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.error.subject))
                        ])
                      : _vm._e(),
                    _c("SelectSubject", {
                      on: { "add-subject": _vm.addSubject }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("TableSubjects", { attrs: { subjects: _vm.subjects } }),
                    _c("small", { staticClass: "text-primary" }, [
                      _vm._v(
                        " Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual "
                      )
                    ])
                  ],
                  1
                )
              ]),
              _c("hr", {}),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("h4", [_vm._v("Con copia a")]),
                    _c("SelectCopy", { on: { "add-copy": _vm.addCopy } })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("TableCopies", {
                      attrs: { copies: _vm.copies },
                      on: { removeCopy: _vm.removeCopy }
                    })
                  ],
                  1
                )
              ]),
              _c("hr", {}),
              typeof _vm.importedFile === "undefined"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mt-2" },
                      [
                        _c("LoadFiles", {
                          attrs: { withTrueCopy: !_vm.isPaper },
                          on: {
                            mainFile: function($event) {
                              _vm.mainFile = $event
                            },
                            additionalFiles: function($event) {
                              _vm.additionalFiles = $event
                            }
                          },
                          model: {
                            value: _vm.inputFormat,
                            callback: function($$v) {
                              _vm.inputFormat = $$v
                            },
                            expression: "inputFormat"
                          }
                        }),
                        _vm.error.onlyPdf
                          ? _c("small", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.error.onlyPdf))
                            ])
                          : _vm._e(),
                        _vm.error.mainFile
                          ? _c("small", { staticClass: "text-danger pl-1" }, [
                              _vm._v(_vm._s(_vm.error.mainFile))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              typeof _vm.importedFile !== "undefined"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-12 mt-2" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-3 text-center" }, [
                          _c(
                            "div",
                            { staticClass: "text-left" },
                            [
                              _c("label", [_vm._v("Formato de ingreso")]),
                              _c("b-form-input", {
                                staticClass: "w-100",
                                attrs: { value: "Digital", disabled: true }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "col-9 text-center" }, [
                          _c(
                            "div",
                            { staticClass: "text-left" },
                            [
                              _c("label", [_vm._v("Nombre del documento")]),
                              _c("b-form-input", {
                                staticClass: "w-100",
                                attrs: {
                                  value: _vm.importedFile.objetoNombre,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.state === "9"
                ? _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("vs-textarea", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: _vm.state === "9", max: 2000 },
                              expression:
                                "{ required: state === '9', max: 2000 }"
                            }
                          ],
                          staticClass: "w-100 mt-3",
                          attrs: {
                            label: "Justificación de edición",
                            width: "100%",
                            name: "justification",
                            height: "100px",
                            maxlength: "900",
                            counter: "900",
                            "data-vv-as": "justificación"
                          },
                          model: {
                            value: _vm.justification,
                            callback: function($$v) {
                              _vm.justification = $$v
                            },
                            expression: "justification"
                          }
                        }),
                        _vm.errors.first("inputDoc.justification")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                                staticStyle: { height: "32px" }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "span-text-validation" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "inputDoc.justification"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row mt-5" }, [
                _c(
                  "div",
                  { staticClass: "col-12 mt-5 text-right" },
                  [
                    !_vm.importedFile && !_vm.fromEditAction
                      ? _c(
                          "vs-button",
                          {
                            staticClass: "mr-2 btn btn-primary",
                            attrs: { disabled: _vm.loading },
                            on: {
                              click: function($event) {
                                return _vm.save("draft")
                              }
                            }
                          },
                          [_vm._v(" Guardar Borrador ")]
                        )
                      : _vm._e(),
                    _c(
                      "vs-button",
                      {
                        staticClass: "mr-2 btn btn-success",
                        attrs: { disabled: _vm.loading },
                        on: { click: _vm.save }
                      },
                      [_vm._v(" Guardar ")]
                    ),
                    _vm.loading
                      ? _c("vs-progress", {
                          staticClass: "mb-1 mt-2",
                          attrs: { indeterminate: "", color: "primary" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c("Confirm", {
        attrs: {
          motherDocNumber: _vm.motherDocNumber,
          isMotherDocument: _vm.isMotherDocument,
          resetData: _vm.resetData,
          dntCode: _vm.dntCode,
          showConfirm: _vm.showConfirm,
          state: _vm.state,
          fromEditActioon: _vm.fromEditAction
        },
        on: { closeModal: _vm.closeConfirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }